<template>
  <el-popover
    placement="left"
    :trigger="trigger"
  >
    <div v-loading="loading" class="material-preview">
      <div
        v-for="(item, index) in materialList"
        :key="index"
      >
        <video
          v-if="item.url && materialType === 2"
          style="height: 600px"
          :src="item.url"
          :poster="item.thumb_url"
          controls="controls"
        />
        <el-image
          v-if="item.url && (materialType === 1 || materialType === 3 || materialType === 4)"
          :src="item.url"
          :style="{
            float: 'left',
            width: (1 / (materialList.length >= 3 ? 3 : materialList.length)) * 100 + '%',
          }"
        />
      </div>
    </div>

    <div slot="reference" class="preview-reference">
      <el-image
        v-for="(item, index) in materialList"
        :key="index"
        :src="item.thumb_url"
        :fit="'contain'"
        :style="{
          float: 'left',
          padding: '1px',
          width: (1 / (materialList.length >= 3 ? 3 : materialList.length)) * 100 + '%',
          height: '50px'
        }"
      />
    </div>
  </el-popover>
</template>

<script>
export default {
  props: {
    materialType: {
      type: Number,
      default: 1,
    },
    url: {
      type: String,
      default: '',
    },
    // 触发方式
    trigger: {
      type: String,
      default: 'hover',
    },
    // 请求参数
    getParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 获取视频地址
    getVideoUrl: {
      type: Function,
      default: null,
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    materialList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data(){
    return {
      loading: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.material-preview {
  overflow: auto;
  max-width: 600px;
  max-height: 852px;
  .el-image,
  video {
    width: 100%;
    padding: 1px;
  }
  video {
    background-color: #000;
  }
  .preview-reference {
    height: 100px;
  }
}
</style>

